module.exports = __webpack_public_path__ + "static/media/go-big-go-home-banner-tablet.ca493af2.webp";